<template>
  <section class="student-panel display-panel" :class="{ 'student-panel-empty': !hasDisplayStudent }">
    <template v-if="hasDisplayStudent">
      <div class="student-identity">
        <div class="student-avatar">
          <img v-if="studentPhoto" :src="studentPhoto" alt="" />
          <i v-else class="fas fa-user-graduate"></i>
        </div>
        <div class="student-name-block">
          <div class="student-code">{{ snapshot.card_number || '-' }}</div>
          <h1>{{ displayStudentNameKh || displayStudentName || '-' }}</h1>
          <h2 v-if="displayStudentNameKh && displayStudentName">{{ displayStudentName }}</h2>
        </div>
      </div>
      <div class="student-info-grid">
        <div class="student-info-item info-date">
          <i class="far fa-calendar-alt"></i>
          <span>{{ $t('customerDisplay.preInvoiceDate') }}</span>
          <strong>{{ displayDate(snapshot.pre_invoice_date) }}</strong>
        </div>
        <div class="student-info-item info-phone">
          <i class="fas fa-phone"></i>
          <span>{{ $t('customerDisplay.phone') }}</span>
          <strong>{{ studentPhone }}</strong>
        </div>
        <div class="student-info-item info-gender">
          <i class="fas fa-venus-mars"></i>
          <span>{{ $t('customerDisplay.gender') }}</span>
          <strong>{{ studentGender }}</strong>
        </div>
        <div class="student-info-item info-grade">
          <i class="fas fa-graduation-cap"></i>
          <span>{{ $t('customerDisplay.grade') }}</span>
          <strong>{{ studentGrade }}</strong>
        </div>
        <div class="student-info-item info-dob">
          <i class="far fa-calendar"></i>
          <span>{{ $t('customerDisplay.dob') }}</span>
          <strong>{{ studentDob }}</strong>
        </div>
      </div>
    </template>
    <div v-else class="student-pending">
      <div class="student-pending-icon"><i class="fas fa-user-graduate"></i></div>
      <strong>{{ $t('customerDisplay.studentPendingTitle') }}</strong>
      <span>{{ $t('customerDisplay.studentPendingHint') }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StudentDisplayPanel',
  props: {
    snapshot: { type: Object, default: null }
  },
  computed: {
    hasDisplayStudent() {
      return Boolean(this.snapshot && (this.snapshot.student_name || this.snapshot.student_name_kh || this.snapshot.card_number))
    },
    displayStudentName() {
      if (!this.snapshot) return ''
      const name = [this.snapshot.last_name_en, this.snapshot.first_name_en].filter(Boolean).join(' ')
      return name || this.snapshot.student_name || ''
    },
    displayStudentNameKh() {
      if (!this.snapshot) return ''
      const name = [this.snapshot.last_name_kh, this.snapshot.first_name_kh].filter(Boolean).join(' ')
      return name || this.snapshot.student_name_kh || ''
    },
    studentDob() {
      return (
        (this.snapshot &&
          (this.snapshot.dob ||
            this.snapshot.date_of_birth ||
            this.snapshot.student_dob ||
            this.snapshot.birth_date)) ||
        '-'
      )
    },
    studentGender() {
      return (
        (this.snapshot &&
          (this.snapshot.gender ||
            this.snapshot.sex ||
            this.snapshot.student_gender)) ||
        '-'
      )
    },
    studentPhone() {
      return (
        (this.snapshot &&
          (this.snapshot.phone ||
            this.snapshot.phone_number ||
            this.snapshot.tel ||
            this.snapshot.student_phone)) ||
        '-'
      )
    },
    studentGrade() {
      return (
        (this.snapshot &&
          (this.snapshot.grade ||
            this.snapshot.grade_name ||
            this.snapshot.grade_name_foreign ||
            (this.snapshot.academic && this.snapshot.academic.grade))) ||
        '-'
      )
    },
    studentPhoto() {
      const photo = this.snapshot
        ? this.snapshot.photo || this.snapshot.photo_url || this.snapshot.student_photo
        : ''
      if (!photo) return ''
      if (/^(https?:)?\/\//.test(photo) || photo.indexOf('/api/files?filePath=') === 0) return photo
      const parts = String(photo).split(/file[_Pp]ath=/)
      return `/api/files?filePath=${parts[parts.length - 1]}`
    }
  },
  methods: {
    displayDate(value) {
      return value || '-'
    }
  }
}
</script>
